export default __webpack_public_path__ + "static/media/season-autumn.c4350e5c.svg";